import $http from '@/resource';
import utils from '@/utils';

const $api = {};

/**
 * 健康上报获取表单接口
 *
 * @returns {Promise<any>}
 */
$api.reportPaper = function(uid) {
  const url = `reportPaper/${uid}`;
  const promise = new Promise(function(resolve){
    $http.get(url).then(function (response) {
      if (response.code == 200) {
        console.log('11111',response)
        resolve(response);
      } else {
        utils.notice(response.msg, 'error');
      }
    });
  });
  return promise;
}

/**
 * 提交健康问卷
 *
 * @param data
 *
 * @returns {Promise<any>}
 */
$api.reportAnswer = function(data) {
  const url = 'reportAnswer';
  const promise = new Promise(function(resolve, reject){
    $http.post(url, data).then(function (response) {
      if (response.code == 200) {
        resolve(response.code);
      } else {
        utils.notice(response.msg, 'error');
      }
    });
  });
  return promise;
}

/**
 * 关注/取关  项目
 *
 * @param changeFocus   1代表关注，0代表取关
 *
 * @returns {Promise<any>}
 */
$api.detailItemFocus = (itemId,changeFocus) => {
    const url = `item/${itemId}/focus`
    const promise = new Promise((resolve) => {
        $http.patch(url, {changeFocus: changeFocus}).then((response) => {
            resolve(response)
        })
    })
    return promise
}

/**
 * 关注/取关  载体
 *
 * @param changeFocus   1代表关注，0代表取关
 *
 * @returns {Promise<any>}
 */
$api.detailCarrierFocus = (itemId,changeFocus) => {
    const url = `carrier/${itemId}/focus`
    const promise = new Promise((resolve) => {
        $http.patch(url, {changeFocus: changeFocus}).then((response) => {
            resolve(response)
        })
    })
    return promise
}


/**
 * 关注/取关
 *
 * @param changeFocus   1代表关注，0代表取关
 *
 * @returns {Promise<any>}
 */
$api.companyDetailFocus = (companyId,changeFocus) => {
    const url = `companys/${companyId}/focus`
    const promise = new Promise((resolve) => {
        $http.patch(url, {isFocus: changeFocus}).then((response) => {
            resolve(response)
        })
    })
    return promise
}


/**
 * 获取标签
 *
 * @param data
 *
 * @returns {Promise<any>}
 *
 * item/{id}/tags
 */
$api.getItemLabData = function(itemId) {
    const url = `item/${itemId}/tags`
    const promise = new Promise((resolve) => {
        $http.get(url).then((response) => {
            resolve(response)
        })
    })
    return promise
}

/**
 * 获取企业标签
 *
 * @param data
 *
 * @returns {Promise<any>}
 *
 * company/{id}/tags
 */
$api.getCompanyLabData = function(id) {
    const url = `companys/${id}/tags`
    const promise = new Promise((resolve) => {
        $http.get(url).then((response) => {
            resolve(response)
        })
    })
    return promise
}
/**
 * 获取企业报表
 *
 * @param data
 *
 * @returns {Promise<any>}
 *
 *  /reports/list
 */
$api.getCompanyReport = async function (data) {
  let url = `reports/app-list`;
    return await $http.get(url,{ params: data });
}

/**
 * 获取标签
 *
 * @param data
 *
 * @returns {Promise<any>}
 *
 * carrier/{id}/tags
 */

$api.getCarrierLabData = async (id) => {

  let url = `carrier/${id}/tags`;
  let res = await $http.get(url);
  return res;
}


/**
 * 获取报表详情
 *
 * @author zhangkaidong 2020-07-02 14:06:15
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url /companys/report-company-detail/
 */
$api.getMoblieReportCompanyDetail = async (id) => {

  let dict ={'id':id}
  let url = `companys/report-company-detail/`;
  let res = await $http.get(url,{params:dict});
  return res;
}


/**
 * 获取年报/月报详情
 *
 * @param data
 *
 * @returns {Promise<any>}
 *
 *  /reports/{id}/detail
 */
$api.getReportDetail = async (id,type)  => {

  let url = type==1?`reports/annual-report`:`reports/monthly-report`;
  let res = await $http.get(url,{params:{id:id}});
  return res;

}



/**
 * 获取编辑记录
 * @param id 编辑id
 * @param data 分页参数
 * @returns {Promise<*>}
 */
$api.getEditRecord = async function (id, data) {
    let url = `reports/${id}/log`;
    return await $http.get(url, {params: data});
    // return {"code":"200","msg":"\u83b7\u53d6\u6570\u636e\u6210\u529f","data":{"count":"26","list":[{"id":"21","opName":"\u6700\u5389\u5bb3\u7684\u586b\u62a5\u4eba","content":"\u586b\u62a5\u4eba\u624b\u673a","type":"-","old":"15185965632","new":"15185965631","createTime":"2020-08-05 17:30:13"},{"id":"22","opName":"\u6700\u5389\u5bb3\u7684\u586b\u62a5\u4eba","content":"\u7d2f\u8ba1\u4ece\u4e1a\u4eba\u5458\u6570","type":"1-\u672c\u6708\u7d2f\u8ba1\u6570","old":"29","new":"1","createTime":"2020-08-05 17:30:13"},{"id":"23","opName":"\u6700\u5389\u5bb3\u7684\u586b\u62a5\u4eba","content":"\u53bb\u5e74\u540c\u671f\u7d2f\u8ba1\u4ece\u4e1a\u4eba\u5458\u6570","type":"\u53bb\u5e74\u540c\u671f\u6570","old":"85","new":"5","createTime":"2020-08-05 17:30:13"},{"id":"24","opName":"\u6700\u5389\u5bb3\u7684\u586b\u62a5\u4eba","content":"\u65b0\u589e\u4ece\u4e1a\u4eba\u5458\u6570","type":"1-\u672c\u6708\u7d2f\u8ba1\u6570","old":"5632","new":"5","createTime":"2020-08-05 17:30:13"},{"id":"25","opName":"\u6700\u5389\u5bb3\u7684\u586b\u62a5\u4eba","content":"\u53bb\u5e74\u540c\u671f\u65b0\u589e\u4ece\u4e1a\u4eba\u5458\u6570","type":"\u53bb\u5e74\u540c\u671f\u6570","old":"-4521","new":"5","createTime":"2020-08-05 17:30:13"},{"id":"26","opName":"\u6700\u5389\u5bb3\u7684\u586b\u62a5\u4eba","content":"\u5de5\u4e1a\u603b\u4ea7\u503c","type":"1-\u672c\u6708\u7d2f\u8ba1\u6570","old":"353.00","new":"5","createTime":"2020-08-05 17:30:13"},{"id":"27","opName":"\u6700\u5389\u5bb3\u7684\u586b\u62a5\u4eba","content":"\u53bb\u5e74\u540c\u671f\u5de5\u4e1a\u603b\u4ea7\u503c","type":"\u53bb\u5e74\u540c\u671f\u6570","old":"5353.00","new":"5","createTime":"2020-08-05 17:30:13"},{"id":"28","opName":"\u6700\u5389\u5bb3\u7684\u586b\u62a5\u4eba","content":"\u8425\u4e1a\u6536\u5165","type":"1-\u672c\u6708\u7d2f\u8ba1\u6570","old":"68.00","new":"1","createTime":"2020-08-05 17:30:13"},{"id":"29","opName":"\u6700\u5389\u5bb3\u7684\u586b\u62a5\u4eba","content":"\u53bb\u5e74\u540c\u671f\u8425\u4e1a\u6536\u5165","type":"\u53bb\u5e74\u540c\u671f\u6570","old":"45.00","new":"8","createTime":"2020-08-05 17:30:13"},{"id":"30","opName":"\u6700\u5389\u5bb3\u7684\u586b\u62a5\u4eba","content":"\u8425\u4e1a\u5229\u6da6","type":"1-\u672c\u6708\u7d2f\u8ba1\u6570","old":"45546.00","new":"8","createTime":"2020-08-05 17:30:13"}]}}
}
export default $api;



// WEBPACK FOOTER //
// ./src/service/mobile/index.js